module.exports = __webpack_public_path__ + "img/3.f2bf711d.png";